export const errorViewTheme = {
   light: {
      backgroundColor: 'bg-gray-100',
      title: {
         color: 'text-gray-900'
      },
      description: {
         color: 'text-gray-600'
      }
   },
   dark: {}
}
